export default __webpack_public_path__ + "static/media/night-of-freestyle-logo.1d85079a.png";